import { buildService } from '../service';
import serviceMethods from '../service_methods';
import { useCallback } from 'react';
const api = buildService('/claim_project_reports/{id}/project_versions', {
  only: ['all', 'get']
});
const useFetchAll = _ref => {
  let {
    projectId,
    setLoading,
    initialQueryParams
  } = _ref;
  const [projectVersions, setProjectVersions, fetchProjectVersions, totalPages] = serviceMethods.useFetch({
    callback: useCallback(async queryParams => {
      const response = await api.all(projectId, queryParams);
      return response;
    }, [projectId]),
    setLoading,
    initialQueryParams,
    paginationResourceField: 'versions'
  });
  return [projectVersions, setProjectVersions, fetchProjectVersions, totalPages];
};
const projectVersionService = {
  useFetchAll
};
export default projectVersionService;